import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import type { Language } from '@ilteducation/content-ref-data-types';
import type { MaterialV1 } from '@ilteducation/content-registry-types';
import ContentToCollection from '@/components/collections/ContentToCollection.vue';
import eventBus from '@/foundations/services/eventBus';
import { defaultSubscriptions, Subscription } from '@/foundations/helpers/defaultSubscriptions';
import { defaultRealms, Realm } from '@/foundations/helpers/defaultRealms';
import { getAllRefData } from '@/data-provider/refDataProvider';
import useMaterial from './use-material';

type Props = {
  title: string;
  resource: unknown;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    title: null,
    resource: null
  },
  setup(__props: any) {



const { getStateColor, getStateIcon } = useMaterial();

const availableSubscriptions = defaultSubscriptions;
const availableLanguages = ref<Language[]>([]);

getAllRefData('languages').then((languages: Language[]) => {
  availableLanguages.value = languages.sort((a: Language, b: Language) => a.language.localeCompare(b.language));
});

const fields = [
  { source: 'preview' },
  { source: 'id', link: 'edit' },
  { source: 'state', sortable: true },
  { source: 'title', sortable: true },
  { source: 'originalTitle', sortable: true },
  {
    source: 'realm',
    label: 'Market',
    sortable: true,
    type: 'chip',
    attributes: {
      color: 'orange',
    },
  },
  { source: 'ages', sortable: true },
  {
    source: 'accessRules.subscriptionType',
    label: 'Subscriptions',
    sortable: true,
  },
];

const filters = computed(() => [
  {
    source: 'state',
    type: 'select',
    attributes: {
      multiple: true,
    },
  },
  {
    source: 'originalTitle',
    type: 'text',
    multiple: true,
  },
  {
    source: 'title',
    type: 'text',
    multiple: true,
  },
  {
    label: 'Language',
    source: 'language',
    type: 'autocomplete',
    attributes: {
      multiple: true,
      choices: availableLanguages.value,
      itemText: (item: Language) => item.language,
      itemValue: (item: Language) => item.languageCode,
      minChars: 1000,
    },
  },
  {
    source: 'realm',
    label: 'Market',
    type: 'autocomplete',
    attributes: {
      multiple: true,
      choices: defaultRealms,
      itemText: (item: Realm) => item.realm,
      itemValue: (item: Realm) => item.code,
      minChars: 1000,
    },
  },
  {
    source: 'accessRules.subscriptionType',
    label: 'Subscription',
    type: 'autocomplete',
    attributes: {
      multiple: true,
      choices: defaultSubscriptions,
      itemText: (item: Subscription) => item.subscription,
      minChars: 1000,
    },
  },
  {
    source: 'availabilityRealms',
    label: 'Available Markets',
    type: 'autocomplete',
    attributes: {
      multiple: true,
      choices: defaultRealms,
      itemText: (item: Realm) => item.realm,
      itemValue: (item: Realm) => item.code,
      minChars: 1000,
    },
  },
  {
    source: 'createdAt',
    label: 'Created',
    type: 'date',
  },
  {
    source: 'lastUpdatedAt',
    label: 'Last Updated',
    type: 'date',
  },
]);

const clipboardSuccessHandler = () => {
  eventBus.$emit('snackbar.open', 'Title has been copied successfully!');
};

const getPreviewUrl = (id: string) => {
  const cfUrl = process.env.VUE_APP_COVERS_DOMAIN;
  return `https://${cfUrl}/public/materialPreviews/${id}/preview.png?height=100`;
};

// va-bulk-action-button clears the table selection as soon as its action resolves, so the
// selected rows are captured here before the dialog opens.
const collectionDialog = ref(false);
const collectionItems = ref<MaterialV1[]>([]);

const openCollectionDialog = (items: MaterialV1[]) => {
  collectionItems.value = items;
  collectionDialog.value = true;
};

const collectionIds = computed(() => collectionItems.value.map((m) => m.id));
const collectionSubscriptions = computed(() => [
  ...new Set(collectionItems.value.flatMap((m) => m.accessRules?.subscriptionType || [])),
]);
const collectionRealms = computed(() => [
  ...new Set(collectionItems.value.flatMap((m) => m.availabilityRealms || [])),
]);

return { __sfc: true,getStateColor, getStateIcon, availableSubscriptions, availableLanguages, fields, filters, clipboardSuccessHandler, getPreviewUrl, collectionDialog, collectionItems, openCollectionDialog, collectionIds, collectionSubscriptions, collectionRealms, ContentToCollection }
}

})